export {BrowserModule} from '../src/Browser/BrowserModule';
export {IBrowserService} from '../src/Browser/IBrowserService';
export {ScreenRotation} from '../src/Browser/ScreenRotation';


// WEBPACK FOOTER //
// /Users/zasa/map/map-core-git/~/tslint-loader??ref--0-1!./api/api.ts